import { API } from "./api";
const mediaOrigin = new URL(API, window.location.origin).origin;

export function mediaUrl(path) {
  if (!path) return "";
  if (/^https:\/\//i.test(path)) return path;
  if (path.startsWith("/api/") || path.startsWith("/media/")) return `${mediaOrigin}${path}`;
  if (path.startsWith("ministry/")) return `${mediaOrigin}/media/${path}`;
  if (/^sermons\/(audio|video|images)\/[^/]+\.[^/]+$/.test(path)) return `${mediaOrigin}/media/${path}`;
  return `${API}/files/${path.replace(/^\//, "")}`;
}
